module.exports = __webpack_public_path__ + "img/ztsb.eb2b0884.png";